module.exports = __webpack_public_path__ + "static/media/meng_hsien_shih.59f997df.jpg";